import React, { Component } from 'react';
import ContentRightPrice from "../../content-right/content-right-price/content-right-price";
import config from '../../../../config';
import './content-left-visible-xs.css'

class ContentLeftVisibleXs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lgShow: false,
            data:this.props.data_visble.data
        }
    }
    render() {
        return (
            <div class="visible-xs">
                <div class="lic"> <span>Purchase Report</span>
                </div>
                <div class="slct_price">
                    <div class="p-select1">
                        <div class="s_icons"> <i class="fa fa-dot-circle-o"></i>
                        </div>
                        <div class="re-s-price"> <span class="rep_sin">$ {config.data.price.single}</span>
                            <br/><span class="rep-s-type">Single user license</span>
                        </div>
                    </div>
                    <div class="p-select2">
                        <div class="t_icons"> <i class="fa fa-circle-o"></i>
                        </div>
                        <div class="re-t-price"> <span class="rep_team">$ {config.data.price.team}</span>
                            <br/><span class="rep-t-type">Team license</span>
                        </div>
                    </div>
                    <div class="p-select3">
                        <div class="c_icons"> <i class="fa fa-circle-o"></i>
                        </div>
                        <div class="re-c-price"> <span class="rep_corp">$ {config.data.price.corporate}</span>
                            <br/><span class="rep-c-type">Corporate license</span>
                        </div>
                    </div>

                    <form>
                        <input type="hidden" name="re_id" id="re_id" value="35348" />
                            <input type="hidden" name="re_type" id="re_type" value="Single User Licence" />
                                <input type="hidden" name="re_title" id="re_title" value="Agave Syrup Market - Trends, Growth and Forecasts (2018 - 2023)" />
                                    <input type="hidden" name="single" id="single" value={config.data.price.single} />
                                        <input type="hidden" name="team" id="team" value={config.data.price.team} />
                                            <input type="hidden" name="corporate" id="corporate" value={config.data.price.corporate} />
                                                <input type="hidden" name="usd" id="usd" value="1" />
                                                    <input type="hidden" name="inr" id="inr" value="63.619999" />
                                                        <input type="hidden" name="eur" id="eur" value="0.8431" />
                                                            <input type="hidden" name="jpy" id="jpy" value="110.710999" />
                                                                <input type="hidden" name="gbp" id="gbp" value="0.75614" />
                    </form>

                </div>
                <div>
                    <button class="customButton" > <i class="fa fa-shopping-cart ccart"></i> Buy Now - <span class="rep_sin" id="rpm">$ {config.data.price.single}</span><span class="latestprice hide" id="latestprice">{config.data.price.single}</span><span class="latestpricelogo hide" id="latestpricelogo">$</span>
                    </button>
                </div>
            </div>
        );
    }


}


export default ContentLeftVisibleXs;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left-visiable-xs/content-left-visible-xs.js